import React, { useState, useRef } from 'react';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useSelector, useDispatch } from 'react-redux';
import { Alert, AlertTitle } from '@material-ui/lab';
import TableCliente from 'components/reservaciones/medico/cliente-table.component';
import { AutocompleteComponent } from 'components/ui/AutocompleteComponent';
import { setCliente } from 'redux/actions/aClientes';
import { getClientesPorBusqueda } from 'redux/actions/aClientes';
import { ClienteForm } from 'components/forms/ClienteForm';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
}));

const Cliente = ({ setIdCliente, doctor, ...props }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  // const [campoCliente, setCampoCliente] = useState('');
  const [showForm, setShowForm] = useState(false);
  const refForm = useRef(null);
  const { data: clientes = '' } = useSelector(state => state.data_clientes);
  const { clients_search } = useSelector(state => state.data_clientes);
  console.log(clientes)

  const handleBuscado = (event, values, esNuevo) => {
    if (values !== null && values.id) {

      dispatch(setCliente(values));
      setIdCliente(values.id);

    }
  };

  const handleNavToPacientesForm = () => {
    localStorage.setItem('redirectDoctorPacientesForm', 'secretaria:reserva');
    history.push('/secretaria/pacientes-atendidos');
  }

  const handleShowFormCerrar = () => {
    setShowForm(false)
  };

  return (
    <div
      style={{
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '300px' }}>
        <GridContainer className={classes.root} style={{ flex: 1 }}>
          <GridItem xs={12}>
            <AutocompleteComponent
              freeSolo={true}
              poblarData={[]}
              onBuscadoChange={(event, values) => handleBuscado(event, values, true)}
              optionLabel={option => option.id ? `${option.cedula_identidad} ${option.nombres} ${option.apellidos}` : ''}
              placeholder="CI/Nombres/Apellidos"
              dispatchFunction={(cadena) => getClientesPorBusqueda(cadena, doctor)}
              dataSearch={clients_search}
              onFocus={() => setShowForm(false)}
            />
          </GridItem>
        </GridContainer>
        {props.hasError && (
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {props.hasError}
          </Alert>
        )}
      </div>

      {!Array.isArray(clientes) && (
        <TableCliente clientes={clientes} titulos={['Cédula', 'Nombres', 'Apellidos', 'Telefono', 'Sexo']} />
      )}
      <IconButton
        style={{ marginTop: '10px', justifyContent: 'flex-end', color: showForm ? 'red' : '' }}
        onClick={handleNavToPacientesForm}
      >
        <AddCircleIcon />
        Añadir paciente
      </IconButton>

      <div ref={refForm}>
        {showForm && <ClienteForm setShowForm={handleShowFormCerrar} doctor={doctor} />}
      </div>

    </div>
  );
};

export default Cliente;
